module.exports = __webpack_public_path__ + "static/media/Golos_Text_Bold.e4ccda02.woff";